import { Controller } from 'stimulus';
import 'src/core-ui/daterangepicker';

export default class extends Controller {
  connect() {
    $(this.element).daterangepicker({ singleDatePicker: true })
  }
}
